import React from 'react';
import { Landing } from './pages/Landing';
function App() {
  return <Landing data-id="element-0" />;
}
export { App };